export default __webpack_public_path__ + "static/media/GroovyGravity_00.5df7e029.png";